import { render, staticRenderFns } from "./Login-page.vue?vue&type=template&id=62fed962&"
import script from "./Login-page.vue?vue&type=script&lang=js&"
export * from "./Login-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports